/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./layout');

// require('./custom-calendar');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
import UUID from 'vue-uuid';
Vue.use(UUID);

Vue.config.devtools = true;

Vue.component('mdb-datatable', require('./components/CustomMDBVue/Tables/Datatable.vue').default);
Vue.component('user-pics-cropper',require('./components/UserImageCropper/UserImageCropper.vue').default);
Vue.component('md-datepicker', require('./components/CustomVueMaterial/components/MdDatepicker/MdDatepicker.vue').default);
Vue.component('custom-tree-select', require('./components/CustomVueMaterial/custom/CustomTreeSelect/CustomTreeSelect.vue').default);
Vue.component('custom-tree-view', require('./components/CustomVueMaterial/custom/CustomTreeSelect/CustomTreeView.vue').default);
Vue.component('allowance-select', require('./components/Custom/AllowanceSelect.vue').default);
Vue.component('custom-file-selector', require('./components/Custom/CustomFileSelector').default);
Vue.component('search-form', require('./components/Custom/SearchForm.vue').default);

// Vue.component('fullcalendar-component', require('./components/CustomFullCalendar/CustomFullCalendar.vue').default);
// require('@fullcalendar/core/locales/ja');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });



let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
